<template>
  <layout-default>
    <div v-if="showNotification" class="notification">
      <div class="notification__text">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.527 4.85092L3.23087 17.3485C3.08044 17.6158 3.00085 17.9188 3.00001 18.2275C2.99916 18.5361 3.0771 18.8396 3.22607 19.1078C3.37504 19.3759 3.58984 19.5994 3.84911 19.7559C4.10838 19.9125 4.40308 19.9966 4.70388 20H19.2961C19.5969 19.9966 19.8916 19.9125 20.1509 19.7559C20.4102 19.5994 20.625 19.3759 20.7739 19.1078C20.9229 18.8396 21.0008 18.5361 21 18.2275C20.9992 17.9188 20.9196 17.6158 20.7691 17.3485L13.473 4.85092C13.3194 4.59116 13.1032 4.3764 12.8452 4.22735C12.5872 4.0783 12.2961 4 12 4C11.7039 4 11.4128 4.0783 11.1548 4.22735C10.8968 4.3764 10.6806 4.59116 10.527 4.85092Z"
            fill="#FFCC33"
            stroke="#38455D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 9V13.5"
            stroke="#38455D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 17H12.0108"
            stroke="#38455D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <p>מכיל מידע רגיש לפי חוק הגנת הפרטיות - המוסר שלא כדין עובר עבירה</p>
      </div>
      <a
        href=""
        class="notification__btn"
        @click.prevent="showNotification = false"
      >
        סגור
      </a>
    </div>
    <MainEdit
      v-if="user"
      :user="user"
      :student="student"
      :district_administrations_ids="district_administrations_ids"
      :institutions_ids="institutions_ids"
      @update="getStudent($route.params.id)"
    />
    <div v-else class="form section section--grey no-data" />

    <div class="main__content">
      <TheStudentMenu :id="parseInt(id)" :user="user" />
      <slot />
    </div>
  </layout-default>
</template>

<script>
import TheStudentMenu from './TheStudentMenu';
import MainEdit from './Student/MainEdit';
import LayoutDefault from '@/Components/Layout/LayoutDefault';
import { mapGetters } from 'vuex';

export default {
  components: { TheStudentMenu, LayoutDefault, MainEdit },
  data() {
    return {
      id: this.$route.params.id,
      user: {},
      student: {},
      institutions_ids: [],
      district_administrations_ids: [],
      showNotification: true
    };
  },
  computed: {
    ...mapGetters({
      userAuth: 'auth/user',
      updated: 'students/updated'
    })
  },
  watch: {
    $route(to, from) {
      if (to.params.id && to.params.id > 0 && to.params.id != this.id) {
        this.id = to.params.id;
        this.getStudent(to.params.id);
      }
    },
    updated(res) {
      this.getStudent(this.$route.params.id);
    }
  },
  created() {
    if (
      !this.student ||
      !this.student.id ||
      this.student.id !== this.$route.params.id
    ) {
      this.getStudent(this.$route.params.id);
    }
  },
  methods: {
    // getStudent(id) {
    //   axios.get('/api/students/' + id).then(res => {
    //     this.district_administrations_ids =
    //       res.data.data.district_administrations_ids;
    //     this.institutions_ids = res.data.data.institutions_ids;
    //     console.log(this.institutions_ids, 'this.institutions_ids');
    //     this.user = res.data.data.user;
    //     this.student = res.data.data.student;
    //   });
    // },
    async getStudent(id) {
      try {
        const params = {};
        if (this.$route.query.project_id) {
          params.project_id = this.$route.query.project_id;
          params.show_student_for_project = 1;
        }
        console.log(params);
        const res = await axios.get('/api/students/' + id, {
          params
        });
        this.district_administrations_ids =
          res.data.data.district_administrations_ids;
        this.institutions_ids = res.data.data.institutions_ids;
        console.log(this.institutions_ids, 'this.institutions_ids');
        this.user = res.data.data.user;
        this.student = res.data.data.student;
      } catch (error) {
        this.$toastr.e('Permission denied');
        this.$router.replace('/');
      }
    }
  }
};
</script>
